module.exports = __webpack_public_path__ + "static/img/wechat.c5a8941.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/wechat.png
// module id = +jFr
// module chunks = 0